import { Check } from "lucide-react";
import { siteContent } from "@/data/siteContent";

export const ApproachSection = () => {
  const { approach, possibility } = siteContent;

  return (
  <>
    <section id="approach" className="section-shell section-shell--teal" aria-labelledby="approach-title" data-testid="approach-section">
      <div className="site-container">
        <p className="section-kicker" data-testid="approach-kicker">{approach.kicker}</p>
        <h2 id="approach-title" className="section-title" data-testid="approach-title">{approach.heading}</h2>
        <p className="section-intro" data-testid="approach-intro">{approach.introduction}</p>
        <div className="approach-path" data-testid="approach-path">
          {approach.steps.map((step, index) => (
            <article className="approach-step" key={step.title} data-testid={`approach-step-${index + 1}`}>
              <h3 data-testid={`approach-step-${index + 1}-title`}>{step.title}</h3>
              <p data-testid={`approach-step-${index + 1}-copy`}>{step.copy}</p>
            </article>
          ))}
        </div>
      </div>
    </section>

    <section className="section-shell section-shell--paper" aria-labelledby="possibility-title" data-testid="possibility-section">
      <div className="site-container possibility-layout">
        <div>
          <h2 id="possibility-title" className="section-title section-title--compact" data-testid="possibility-title">
            {possibility.heading}
          </h2>
          <p className="section-intro" data-testid="possibility-intro">
            {possibility.introduction}
          </p>
        </div>
        <ul className="possibility-list" data-testid="possibility-list">
          {possibility.items.map((item, index) => (
            <li key={item} data-testid={`possibility-item-${index + 1}`}>
              <Check size={18} aria-hidden="true" /> {item}
            </li>
          ))}
        </ul>
      </div>
    </section>
  </>
  );
};